import React from 'react'

import Button from 'components/Form/Button'
import { InputRaw } from 'components/Form/Input'
import Select from 'components/Form/Select'
import {
    FilterActions, FilterField, FilterGrid, FiltersRoot,
} from './styled'

export default function ResearchFilters({
    competitorOptions, conditionOptions, filters, onFilterChange, onQueryChange,
    onReset, periodOptions, query, sourceOptions, t,
}) {
    return (
        <FiltersRoot onSubmit={event => event.preventDefault()}>
            <FilterGrid>
                <FilterField>
                    <Select
                        large
                        id="competitive-intelligence-source"
                        placeholder={t('competitive_intelligence_research_source_label')}
                        value={filters.source || 'all'}
                        options={sourceOptions}
                        onChange={value => onFilterChange('source', value === 'all' ? '' : value)}
                    />
                </FilterField>
                <FilterField>
                    <Select
                        large
                        id="competitive-intelligence-competitor"
                        placeholder={t('competitive_intelligence_research_competitor')}
                        value={filters.competitor || 'all'}
                        options={competitorOptions}
                        onChange={value => onFilterChange('competitor', value === 'all' ? '' : value)}
                    />
                </FilterField>
                <FilterField>
                    <Select
                        large
                        id="competitive-intelligence-condition"
                        placeholder={t('competitive_intelligence_research_conditions')}
                        value={filters.condition || 'all'}
                        options={conditionOptions}
                        onChange={value => onFilterChange('condition', value === 'all' ? '' : value)}
                    />
                </FilterField>
                <FilterField>
                    <Select
                        large
                        id="competitive-intelligence-period"
                        placeholder={t('competitive_intelligence_research_period')}
                        value={filters.period || 'all'}
                        options={periodOptions}
                        onChange={value => onFilterChange('period', value === 'all' ? '' : value)}
                    />
                </FilterField>
                <FilterField>
                    <Select
                        large
                        id="competitive-intelligence-sort"
                        placeholder={t('competitive_intelligence_research_sort')}
                        value={filters.sort}
                        options={[
                            { id: 'newest', title: t('competitive_intelligence_research_sort_newest') },
                            { id: 'oldest', title: t('competitive_intelligence_research_sort_oldest') },
                            { id: 'new-added', title: t('competitive_intelligence_research_sort_added') },
                            { id: 'cited', title: t('competitive_intelligence_research_sort_cited') },
                            { id: 'trending', title: t('competitive_intelligence_research_sort_trending') },
                        ]}
                        onChange={value => onFilterChange('sort', value)}
                    />
                </FilterField>
                <FilterField $wide>
                    <InputRaw
                        holder
                        id="competitive-intelligence-research-search"
                        type="search"
                        placeholder={t('competitive_intelligence_research_search_placeholder')}
                        value={query}
                        onChange={event => onQueryChange(event.target.value)}
                    />
                </FilterField>
                <FilterActions>
                    <Button color="blue" link nospace onClick={onReset}>
                        {t('competitive_intelligence_research_clear_filters')}
                    </Button>
                </FilterActions>
            </FilterGrid>
        </FiltersRoot>
    )
}
